import { getReconMismatchesBlotterDefaultStartDate } from '@src/containers/Blotters/Reconciliation/ReconMismatches/getReconMismatchesBlotterDefaultStartDate';
import { RECON_MISMATCHES_BLOTTER_PREFIX } from '@src/containers/Blotters/Reconciliation/tokens';
import { hasDateRangeFilter } from '@talos/kyoko';
import { forEach } from 'lodash-es';

/**
 * For release 2.39 -> 2.40 we are adding a date range selector to the ReconMismatches blotter.
 * You should always have a date range set.
 * This migration sets the default start date on the
 */
export function ensureReconMismatchesBlotterTabsHaveStartDate(config: any) {
  const blotterTabs: object | undefined = config?.blotters2;
  if (blotterTabs == null) {
    return;
  }

  forEach(blotterTabs, (value: any, key) => {
    if (key.includes(RECON_MISMATCHES_BLOTTER_PREFIX)) {
      if (!hasDateRangeFilter(value.filter)) {
        value.filter = {
          ...(value.filter ?? {}), // value.filter might be undefined still
          StartDate: getReconMismatchesBlotterDefaultStartDate(),
        };
      }
    }
  });
}
